import { render, staticRenderFns } from "./Evaluasi2.vue?vue&type=template&id=2be04628&"
import script from "./Evaluasi2.vue?vue&type=script&lang=js&"
export * from "./Evaluasi2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports